export enum MensagensSemantiscaRegrasEnum {
    REGRA_MULTIPLAS_FORMULAS = 'Regra com múltiplas fórmulas ou blocos devem estar inseridas em apenas um bloco principal (E/OU).',
    BLOCO_OU_PRIMEIRO_NIVEL = 'O bloco OU deve ser utilizado apenas no primeiro nível.',
    MINIMO_FORMULAS = 'Favor inserir pelo menos duas fórmulas dentro de um bloco.',
    ARVORE_LIGAR = 'Insira a regra para ligar antes de salvar.',
    ARVORE_MANTER_LIGADO = 'Insira a regra para manter a aeração ligada antes de salvar.',
}
